import { useState } from "react";
import { graphql, useMutation } from "react-relay";

import type { useSendLlmMessageMutation } from "./__generated__/useSendLlmMessageMutation.graphql";

const sendLlmMessageMutation = graphql`
  mutation useSendLlmMessageMutation($input: SendMessageInput!) {
    sendMessage(input: $input) {
      userMessage {
        id
        content
      }
      llmConversation {
        id
        llmInteractions {
          id
          status
        }
      }
    }
  }
`;

interface SendOptionsType {
  attachmentHandles?: string[];
}

export const useSendLlmMessage = ({ llmConversationId }: { llmConversationId?: string }) => {
  const [commitMutation, isMutationInFlight] = useMutation<useSendLlmMessageMutation>(sendLlmMessageMutation);
  const [isSending, setIsSending] = useState(false);

  const sendMessage = async (message: string, options?: SendOptionsType) => {
    setIsSending(true);

    const attachments = options?.attachmentHandles?.length
      ? options.attachmentHandles.map((handle) => ({ handle }))
      : undefined;

    return new Promise<void>((resolve, reject) => {
      commitMutation({
        variables: {
          input: {
            llmConversationId,
            message,
            attachments,
          },
        },
        onCompleted: () => {
          setIsSending(false);
          resolve();
        },
        onError: (error) => {
          setIsSending(false);
          reject(error);
        },
      });
    });
  };

  return {
    sendMessage,
    isSending: isSending || isMutationInFlight,
  };
};
